"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryRef = exports.Category = void 0;
let CategoryRef = exports.CategoryRef = void 0;
let Category = exports.Category = void 0;
(function (_Category) {
  function isTranslated(category, locale) {
    const translation = category.i18n[localeCode(locale)];
    return isNonEmpty(translation);
  }
  _Category.isTranslated = isTranslated;
  function translation(category, locale) {
    const [translation] = Category.translations(category, locale);
    return translation;
  }
  _Category.translation = translation;
  function translations(input, locale) {
    const code = locale ? localeCode(locale) : undefined;
    const categories = Array.isArray(input) ? input : [input];
    return categories.reduce((result, category) => {
      const translated = (code ? [category.i18n[code]] : Object.values(category.i18n)).filter(isNonEmpty).map(translation => {
        return {
          id: category.id,
          locale: translation.locale.code,
          slug: translation.slug,
          name: translation.name,
          description: translation.description,
          public_stories_number: translation.public_stories_number
        };
      });
      return [...result, ...translated];
    }, []);
  }
  _Category.translations = translations;
})(Category || (exports.Category = Category = {}));
function isNonEmpty(translation) {
  return Boolean(translation && translation.name && translation.slug);
}
function localeCode(locale) {
  return typeof locale === 'string' ? locale : locale.code;
}